import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import useProfile from '@/shared/navigation/site-navigation/useProfile';
import { hardRedirect } from '@/core/navigation/redirect.service';
import httpService from '@/core/http/http.service';
import b2bSiteContextService from '@/b2b/shared/site-context.service';
import b2cSiteContextService from '@/b2c/shared/site-context.service';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import pageStore from '@/shared/content/page.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerPrivateToggle',
  setup(__props) {

const { isSignedInAsPartner } = useProfile();
const globalLabels = useGlobalLabels(GlobalLabels.topBanner);

const logout = async() => {
    await httpService.post(b2bSiteContextService.logoutEndpointUrl);
    hardRedirect(pageStore.changeCountryUrl);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(!_unref(isSignedInAsPartner) ? 'span' : 'button'), {
      class: _normalizeClass([{ 'c-magic-line--underline-static': !_unref(isSignedInAsPartner) }, "c-magic-line text-12 xl:text-14"]),
      onClick: _withModifiers(logout, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(globalLabels).private), 1)
      ]),
      _: 1
    }, 8, ["class", "onClick"])),
    _createVNode(RouterLinkConditional, {
      to: _unref(isSignedInAsPartner) ? '' : _unref(b2cSiteContextService).b2bLoginLink?.url,
      class: _normalizeClass([{ 'c-magic-line--underline-static': _unref(isSignedInAsPartner) }, "c-magic-line text-12 xl:text-14"]),
      "spa-enabled": _unref(isSignedInAsPartner) ? false : _unref(b2cSiteContextService).b2bLoginLink?.spaLink
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(globalLabels).partner), 1)
      ]),
      _: 1
    }, 8, ["to", "class", "spa-enabled"])
  ], 64))
}
}

})